/* requires:
polyfill.js
*/

// display the current year in the footer
document.querySelector('.footer-year').innerHTML = new Date().getFullYear();
